"use client";
import React, { useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import SlideCarousel from "@/components/SlideCarousel";
import Ratio from "react-bootstrap/Ratio";
import { useQueryClient } from "@tanstack/react-query";
import { modalHelper } from "@/components/services/QueryDataHelper";

function BestBuyHomesPage() {
  const queryClient = useQueryClient();
  const { setModal } = modalHelper(queryClient);    
  useEffect(() => {
      setModal("bestbuylist");
  }, [])    
  
  return (
    <>
      <section className="StyledSection"> 
      <Container>
      <Row>
        <Col>
          <Card bg="trans-white">
            <Card.Body>
              <Card.Title><h1 className="blue-color">RES Luxury Group - Real Estate Best Buy List</h1></Card.Title>
              <Card.Subtitle><h2>Stay informed of all homes for sale that are listed for $75 per sq. ft or less.</h2></Card.Subtitle>
              <Card.Text as="div">
                <p className="indent">Your list will segment "pool homes", "water properties", and "acreage". The list will also show you which properties fall into the Opportunity Zones tax incentive program.</p>
                <Row>
                  <Col className="py-2">
                    <Ratio aspectRatio="16x9">
                      <iframe className="w-100" src="https://www.youtube.com/embed?listType=playlist&list=PLjBxLKqSLoEb-iAO81DsDIWjaeH_EX5al&modestbranding=1&autoplay=0&rel=0&fs=0" allowFullScreen allow="autoplay"></iframe>
                    </Ratio>
                  </Col>
                </Row>                              
              </Card.Text>              
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col className="py-2">       
          <SlideCarousel className="featured-carousel" slideType="featured" queryValue="featured" slideCount={4} controls={false} cardWrapper={true} bg="trans-black" />                
        </Col>
      </Row>
    </Container>
    </section>
  </>
  );
}

  
  export default BestBuyHomesPage;